import { useEffect, useState } from 'react';

/** Debounced search box — emits `onChange` 300ms after typing settles. */
export function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  const [local, setLocal] = useState(value);

  // Keep the field in sync if the parent resets the term externally.
  useEffect(() => setLocal(value), [value]);

  useEffect(() => {
    const id = window.setTimeout(() => {
      if (local !== value) onChange(local.trim());
    }, 300);
    return () => window.clearTimeout(id);
  }, [local]);

  return (
    <div className="relative w-64">
      <svg
        viewBox="0 0 24 24"
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-cream-400"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.2-3.2" />
      </svg>
      <input
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl border border-cream-600/20 bg-ink-900/70 py-2 pl-9 pr-3 text-sm text-cream-100 placeholder:text-cream-600 outline-none transition-colors focus:border-saffron-500/50 focus:bg-ink-850"
      />
    </div>
  );
}
